export const getVisibleWidth = () => {
  return (
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth ||
    0
  );
};

export const getVisibleHeight = () => {
  return (
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight ||
    0
  );
};

export const getElementHeight = el => {
  return el.clientHeight || el.offsetHeight || el.scrollHeight;
};

export const getElementWidth = el => {
  return el.clientWidth || el.offsetWidth || el.scrollWidth;
};



// WEBPACK FOOTER //
// ./src/common/utils/browser.js